export default __webpack_public_path__ + "static/media/tat_img6.2e4ebab5.webp";